<template>
  <v-system-bar
    app
    height="36px"
    class="justify-center px-1 darktext--text font-weight-bold"
    v-if="
      productPlan.meta &&
      (productPlan.meta.plan_properties.status == 'incomplete' ||
        productPlan.meta.plan_properties.status == 'past_due')
    "
    :class="mobile() ? 'text-caption' : 'text-body-2'"
    color="redlight"
  >
    <p class="d-block my-0" :style="mobile() ? 'line-height:1' : ''">
      {{ $t("paymentFailedMsg") }}
      <a
        color="accent"
        class="text-decoration-underline"
        @click="getStripePortal()"
      >
        {{ $t("updatePaymentFailed") }}
      </a>
      {{ $t("paymentFailedMsg2") }}
    </p>
  </v-system-bar>
</template>
<script>
import { getStripePortal } from "../api/spaceApi";
import { repeatedMethodsMixin } from "../mixins/repeatedMethodsMixin";
export default {
  mixins: [repeatedMethodsMixin],
  data: function () {
    return {
      spaceId: window.$cookies.get("space_id"),
    };
  },
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    },
  },
  methods: {
    async getStripePortal() {
      try {
        const response = await getStripePortal(this.spaceId);
        if (response.status) {
          if (response.status == 200) {
            window.location.href = response.data.meta.stripe_portal_url;
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.$emit("proceedError");
          }
        }
      }
    },
  },
};
</script>

